import React from 'react';
import { motion } from 'framer-motion';
import { Zap, ShieldCheck } from 'lucide-react';
import { CTAButton } from './Shared';
export const HeroSection = () => {
  return <section className="relative min-h-screen flex items-center justify-center pt-20 pb-16 px-4 overflow-hidden" data-id="element-78">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-dark-900 z-0" data-id="element-79"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[500px] bg-gold-500/10 blur-[120px] rounded-full z-0 pointer-events-none" data-id="element-80"></div>

      <div className="relative z-10 max-w-6xl mx-auto w-full grid lg:grid-cols-2 gap-12 items-center" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center lg:text-left" data-id="element-82">
          <div className="inline-block border border-gold-500/30 bg-gold-500/10 text-gold-400 font-semibold tracking-widest uppercase text-xs md:text-sm py-1.5 px-4 rounded-full mb-6" data-id="element-83">
            El Protocolo de 21 Días
          </div>
          <h1 className="font-oswald text-5xl md:text-6xl lg:text-7xl font-bold text-white uppercase tracking-tight leading-[1.1] mb-6" data-id="element-84">
            Hombre Apagado{' '}
            <span className="text-gold-500 block mt-2" data-id="element-85">No Más</span>
          </h1>
          <h2 className="text-lg md:text-xl text-zinc-400 mb-10 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-86">
            Deja de arrastrarte por la vida y recupera la energía, el enfoque y
            la virilidad que el estilo de vida moderno te robó.
          </h2>

          <div className="flex flex-col items-center lg:items-start gap-4" data-id="element-87">
            {/* Arrow label pointing to CTA */}
            <motion.div animate={{
            y: [0, 6, 0]
          }} transition={{
            repeat: Infinity,
            duration: 1.6,
            ease: 'easeInOut'
          }} className="flex items-center gap-2 -mb-1" data-id="element-88">
              <span className="font-oswald text-gold-400 text-base md:text-lg font-bold uppercase tracking-wider" data-id="element-89">
                ⚡ El cambio empieza aquí
              </span>
              <img src="https://cdn.magicpatterns.com/uploads/1aJVLdN7ZMszMznB4brdYD/manito.png" alt="Mano apuntando al botón" className="w-12 h-12 md:w-14 md:h-14 object-contain drop-shadow-[0_2px_6px_rgba(0,0,0,0.4)]" data-id="element-90" />
            </motion.div>

            <CTAButton data-id="element-91">¡Quiero volver a encenderme!</CTAButton>

            <div className="flex flex-col gap-2 text-sm md:text-base text-zinc-400 max-w-md text-center lg:text-left" data-id="element-92">
              <div className="flex items-start gap-2" data-id="element-93">
                <Zap className="w-4 h-4 text-gold-500 shrink-0 mt-0.5" data-id="element-94" />
                <span data-id="element-95">
                  Págalo en hasta{' '}
                  <span className="text-white font-semibold" data-id="element-96">
                    11 cuotas de $2,454 COP
                  </span>
                  . Menos que un café por semana — descarga inmediata.
                </span>
              </div>
              <div className="flex items-start gap-2" data-id="element-97">
                <ShieldCheck className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-98" />
                <span data-id="element-99">
                  <span className="text-white font-semibold" data-id="element-100">
                    Garantía de 7 días
                  </span>{' '}
                  — Si no te sirve, te devolvemos el dinero. Sin preguntas.
                </span>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative mx-auto w-full max-w-lg lg:max-w-none" data-id="element-101">
          <div className="absolute inset-0 bg-gradient-to-t from-dark-900 via-transparent to-transparent z-10 lg:hidden" data-id="element-102"></div>
          <motion.img animate={{
          y: [0, -15, 0]
        }} transition={{
          repeat: Infinity,
          duration: 6,
          ease: 'easeInOut'
        }} src="https://cdn.magicpatterns.com/uploads/9h8seUYueD9nPUJzA8E2d7/portada_hombre_apagado_nunca_mas.png" alt="Hombre Apagado No Más - Protocolo de 21 Días" className="w-full h-auto object-contain drop-shadow-[0_20px_50px_rgba(212,165,116,0.15)] relative z-0" data-id="element-103" />
        </motion.div>
      </div>
    </section>;
};